import * as React from "react";

import EventUtils from "../../utils/event-utils";
import SimpleReactValidator from "simple-react-validator";
import styles from "../../styles/generic/localized-input";
import { withCustomStyles } from "../hocs/with-custom-styles";
import { TextField, withStyles, WithStyles } from "@material-ui/core";
import { CustomStyles, Localizations, LocalizedStrings, LocalizedValues } from "../../types";

/**
 * Interface describing component properties
 */
interface Props extends WithStyles<typeof styles> {
  required?: boolean;
  disabled?: boolean;
  customStyles?: CustomStyles;
  localizations: Localizations;
  validator: SimpleReactValidator;
  localizedValues: LocalizedValues;
  localizedStrings: LocalizedStrings;
  onChange: (locale: string, value: string) => void;
}

/**
 * Interface describing component state
 */
interface State { }

/**
 * Localizen inputfield component
 */
class LocalizedInput extends React.Component<Props, State> {

  /**
   * Constructor
   * 
   * @param props properties
   */
  constructor(props: Props) {
    super(props);
    this.state = { };
  }

  /**
   * Component render
   */
  public render = () => {
    const { classes, customStyles } = this.props;

    return (
      <div
        className={ classes.container }
        style={ customStyles?.container }
      >
        { this.renderLocalizedInputs() }
      </div>
    );
  }

  /**
   * Method for rendering localized inputs
   */
  private renderLocalizedInputs = () => {
    const { localizations, localizedStrings, localizedValues, disabled } = this.props;
    const localizationKeys = EventUtils.getLocalizationKeys();

    return localizationKeys.map((key: string, index: number) => {

      if (!localizations[key as keyof Localizations]) {
        return null;
      }

      const localizedString: string = localizedStrings[key as keyof object];
      const localizedValue: string = localizedValues[key as keyof object];

      return (
        <React.Fragment key={ index }>
          <TextField
            disabled={ disabled }
            label={ localizedString }
            onChange={ this.onChange(key) }
            value={ localizedValue }
          />
          { this.renderValidatorMessage(`${ localizedString.split(" ").join("_") }_${ key }`, localizedValue) }
        </React.Fragment>
      );
    });
  }

  /**
   * Method for rendering validator message
   *
   * @param field field
   * @param value value
   */
  private renderValidatorMessage = (field: string, value: string) => {
    const { validator, required } = this.props;

    if (!required) {
      return null;
    }

    return validator.message(field, value, "required");
  }

  /**
   * Method for changing localized input value
   *
   * @param key key
   * @param event event
   */
  private onChange = (key: string) => (event: React.ChangeEvent<any>) => {
    const { onChange } = this.props;
    const value = event.target.value;
    onChange(key, value);
  }

}

const Styled = withStyles(styles)(LocalizedInput);
const CustomStyled = withCustomStyles("generic/localized-input")(Styled);

export default CustomStyled;
